import createApiClient from '../createApiClient'
import ENDPOINTS from './endpoints'

const apiClient = createApiClient()

const cloneFormData = (formData) => {
  const next = new FormData()
  for (const [key, value] of formData.entries()) {
    next.append(key, value)
  }
  return next
}

const tryCandidatePost = async (candidates = [], formData) => {
  let lastError = null
  for (const path of candidates) {
    try {
      return await apiClient.post(path, cloneFormData(formData))
    } catch (error) {
      lastError = error
      const status = error?.response?.status
      if (status && status !== 404) {
        throw error
      }
    }
  }
  throw lastError || new Error('No matching API endpoint available')
}

const vendorApi = {
  loginVendor(formData) {
    return apiClient.post(ENDPOINTS.LOGIN_VENDOR, formData)
  },

  registerVendor(formData) {
    return apiClient.post(ENDPOINTS.REGISTER_VENDOR, formData)
  },

  requestPasswordReset(formData) {
    return tryCandidatePost(ENDPOINTS.FORGOT_PASSWORD_CANDIDATES, formData)
  },

  verifyPasswordReset(formData) {
    return tryCandidatePost(ENDPOINTS.FORGOT_PASSWORD_VERIFY_CANDIDATES, formData)
  },

  getProfileVendor(formData) {
    return apiClient.post(ENDPOINTS.GET_PROFILE_VENDOR, formData)
  },

  updateProfileVendor(formData) {
    return tryCandidatePost(ENDPOINTS.UPDATE_PROFILE_VENDOR_CANDIDATES, formData)
  },

  changePasswordVendor(formData) {
    return tryCandidatePost(ENDPOINTS.CHANGE_PASSWORD_VENDOR_CANDIDATES, formData)
  },

  listBusinessVendor(formData) {
    return apiClient.post(ENDPOINTS.LIST_BUSINESS_VENDOR, formData)
  },

  addBusinessVendor(formData) {
    return apiClient.post(ENDPOINTS.ADD_BUSINESS_VENDOR, formData)
  },

  editBusinessVendor(formData) {
    return apiClient.post(ENDPOINTS.EDIT_BUSINESS_VENDOR, formData)
  },

  updateBusinessVendor(formData) {
    return apiClient.post(ENDPOINTS.UPDATE_BUSINESS_VENDOR, formData)
  },

  updateBusinessContactVendor(formData) {
    return apiClient.post(ENDPOINTS.UPDATE_BUSINESS_CONTACT_VENDOR, formData)
  },

  updateBusinessDocumentsVendor(formData) {
    return apiClient.post(ENDPOINTS.UPDATE_BUSINESS_DOCUMENTS_VENDOR, formData)
  },

  deleteBusinessDocumentsVendor(formData) {
    return apiClient.post(ENDPOINTS.DELETE_BUSINESS_DOCUMENTS_VENDOR, formData)
  },

  updateBusinessNotificationsVendor(formData) {
    return apiClient.post(ENDPOINTS.UPDATE_BUSINESS_NOTIFICATIONS_VENDOR, formData)
  },

  addBusinessVendorContact(formData) {
    return apiClient.post(ENDPOINTS.ADD_BUSINESS_VENDOR_CONTACT, formData)
  },

  getBusinessVendorContact(formData) {
    return apiClient.post(ENDPOINTS.GET_BUSINESS_VENDOR_CONTACT, formData)
  },

  updateBusinessVendorContact(formData) {
    return apiClient.post(ENDPOINTS.UPDATE_BUSINESS_VENDOR_CONTACT, formData)
  },

  deleteBusinessVendorContact(formData) {
    return apiClient.post(ENDPOINTS.DELETE_BUSINESS_VENDOR_CONTACT, formData)
  },

  updateBusinessBankVendor(formData) {
    return apiClient.post(ENDPOINTS.UPDATE_BUSINESS_BANK_VENDOR, formData)
  },

  deleteBusinessVendor(formData) {
    return apiClient.post(ENDPOINTS.DELETE_BUSINESS_VENDOR, formData)
  },

  addVendorBusinessVenue(formData) {
    return apiClient.post(ENDPOINTS.ADD_VENDOR_BUSINESS_VENUE, formData)
  },

  getVenueHighlights(formData) {
    return apiClient.post(ENDPOINTS.GET_VENUE_HIGHLIGHTS, formData)
  },

  getVenueTypes(formData) {
    return apiClient.post(ENDPOINTS.GET_VENUE_TYPES, formData)
  },

  getVenueEventsHosted(formData) {
    return apiClient.post(ENDPOINTS.GET_VENUE_EVENTS_HOSTED, formData)
  },

  getVenueAmenities(formData) {
    return apiClient.post(ENDPOINTS.GET_VENUE_AMENITIES, formData)
  },

  getVenueInhouseServices(formData) {
    return apiClient.post(ENDPOINTS.GET_VENUE_INHOUSE_SERVICES, formData)
  },

  getVenueFacilityDetails(formData) {
    return apiClient.post(ENDPOINTS.GET_VENUE_FACILITY_DETAILS, formData)
  },

  getServiceVendorCategories(formData) {
    return apiClient.post(ENDPOINTS.GET_SERVICE_VENDOR_CATEGORIES, formData)
  },

  addServiceVendor(formData) {
    return apiClient.post(ENDPOINTS.ADD_SERVICE_VENDOR, formData)
  },

  updateServiceVendor(formData) {
    return apiClient.post(ENDPOINTS.UPDATE_SERVICE_VENDOR, formData)
  },

  deleteServiceVendor(formData) {
    return apiClient.post(ENDPOINTS.DELETE_SERVICE_VENDOR, formData)
  },

  listServiceVendors(formData) {
    return apiClient.post(ENDPOINTS.LIST_SERVICE_VENDORS, formData)
  },

  listServiceCatalogThemes(formData) {
    return apiClient.post(ENDPOINTS.LIST_SERVICE_CATALOG_THEMES, formData)
  },

  listServiceCatalogStyles(formData) {
    return apiClient.post(ENDPOINTS.LIST_SERVICE_CATALOG_STYLES, formData)
  },

  listServiceCatalogFields(formData) {
    return apiClient.post(ENDPOINTS.LIST_SERVICE_CATALOG_FIELDS, formData)
  },

  updateServiceVendorMetaDetails(formData) {
    return apiClient.post(ENDPOINTS.UPDATE_SERVICE_VENDOR_META_DETAILS, formData)
  },

  getServiceVendorMetaDetails(formData) {
    return apiClient.post(ENDPOINTS.GET_SERVICE_VENDOR_META_DETAILS, formData)
  },

  getServiceVendorPolicyDetails(formData) {
    return apiClient.post(ENDPOINTS.GET_SERVICE_VENDOR_POLICY_DETAILS, formData)
  },

  updateServiceVendorPolicyDetails(formData) {
    return apiClient.post(ENDPOINTS.UPDATE_SERVICE_VENDOR_POLICY_DETAILS, formData)
  },

  addServiceVendorGallery(formData) {
    return apiClient.post(ENDPOINTS.ADD_SERVICE_VENDOR_GALLERY, formData)
  },

  getServiceVendorGallery(formData) {
    return apiClient.post(ENDPOINTS.GET_SERVICE_VENDOR_GALLERY, formData)
  },

  deleteServiceVendorGallery(formData) {
    return apiClient.post(ENDPOINTS.DELETE_SERVICE_VENDOR_GALLERY, formData)
  },

  updateServiceVendorCoverImage(formData) {
    return apiClient.post(ENDPOINTS.UPDATE_SERVICE_VENDOR_COVER_IMAGE, formData)
  },

  editServiceCatalogVendor(formData) {
    return apiClient.post(ENDPOINTS.EDIT_SERVICE_CATALOG_VENDOR, formData)
  },

  addServiceCatalogVendor(formData) {
    return apiClient.post(ENDPOINTS.ADD_SERVICE_CATALOG_VENDOR, formData)
  },

  addServiceCatalogServiceVendor(formData) {
    return apiClient.post(ENDPOINTS.ADD_SERVICE_CATALOG_SERVICE_VENDOR, formData)
  },

  listServiceCatalogServiceVendor(formData) {
    return apiClient.post(ENDPOINTS.LIST_SERVICE_CATALOG_SERVICE_VENDOR, formData)
  },

  publishServiceVendorDetails(formData) {
    return apiClient.post(ENDPOINTS.PUBLISH_SERVICE_VENDOR_DETAILS, formData)
  },

  listVenuesBusinessVendor(formData) {
    return apiClient.post(ENDPOINTS.LIST_VENUES_BUSINESS_VENDOR, formData)
  },

  updateVendorVenueDetails(formData) {
    return apiClient.post(ENDPOINTS.UPDATE_VENDOR_VENUE_DETAILS, formData)
  },

  publishVendorVenueDetails(formData) {
    return apiClient.post(ENDPOINTS.PUBLISH_VENDOR_VENUE_DETAILS, formData)
  },

  addPackageVenue(formData) {
    return apiClient.post(ENDPOINTS.ADD_PACKAGE_VENUE, formData)
  },

  updatePackageVenue(formData) {
    return apiClient.post(ENDPOINTS.UPDATE_PACKAGE_VENUE, formData)
  },

  editPackageVenue(formData) {
    return apiClient.post(ENDPOINTS.EDIT_PACKAGE_VENUE, formData)
  },

  getPackagesVenue(formData) {
    return apiClient.post(ENDPOINTS.GET_PACKAGES_VENUE, formData)
  },

  deletePackageVenue(formData) {
    return apiClient.post(ENDPOINTS.DELETE_PACKAGE_VENUE, formData)
  },

  addPoliciesVenue(formData) {
    return apiClient.post(ENDPOINTS.ADD_POLICIES_VENUE, formData)
  },

  editPoliciesVenue(formData) {
    return apiClient.post(ENDPOINTS.EDIT_POLICIES_VENUE, formData)
  },

  addVenueVendorPartner(formData) {
    return apiClient.post(ENDPOINTS.ADD_VENUE_VENDOR_PARTNER, formData)
  },

  updateVenueVendorPartner(formData) {
    return apiClient.post(ENDPOINTS.UPDATE_VENUE_VENDOR_PARTNER, formData)
  },

  listVenueVendorPartners(formData) {
    return apiClient.post(ENDPOINTS.LIST_VENUE_VENDOR_PARTNERS, formData)
  },

  deleteVenueVendorPartner(formData) {
    return apiClient.post(ENDPOINTS.DELETE_VENUE_VENDOR_PARTNER, formData)
  },

  getVenueGalleryCategories(formData) {
    return apiClient.post(ENDPOINTS.GET_VENUE_GALLERY_CATEGORIES, formData)
  },

  getVenueGallery(formData) {
    return apiClient.post(ENDPOINTS.GET_VENUE_GALLERY, formData)
  },

  addVenueGallery(formData) {
    return apiClient.post(ENDPOINTS.ADD_VENUE_GALLERY, formData)
  },

  deleteVenueGallery(formData) {
    return apiClient.post(ENDPOINTS.DELETE_VENUE_GALLERY, formData)
  },

  updateVenueCoverImage(formData) {
    return apiClient.post(ENDPOINTS.UPDATE_VENUE_COVER_IMAGE, formData)
  },

  getVenueMetaDetails(formData) {
    return apiClient.post(ENDPOINTS.GET_VENUE_META_DETAILS, formData)
  },

  updateVenueMetaDetails(formData) {
    return apiClient.post(ENDPOINTS.UPDATE_VENUE_META_DETAILS, formData)
  },

  getVenueAvailability(formData) {
    return apiClient.post(ENDPOINTS.GET_VENUE_AVAILABILITY, formData)
  },

  updateAvailabilityVenue(formData) {
    return apiClient.post(ENDPOINTS.UPDATE_AVAILABILITY_VENUE, formData)
  },

  getEnquiries(formData) {
    return apiClient.post(ENDPOINTS.GET_ENQUIRIES, formData)
  },

  updateNotesEnquiry(formData) {
    return apiClient.post(ENDPOINTS.UPDATE_NOTES_ENQUIRY, formData)
  },

  getSpaceGallery(formData) {
    return apiClient.post(ENDPOINTS.GET_SPACE_GALLERY, formData)
  },

  addSpaceGallery(formData) {
    return apiClient.post(ENDPOINTS.ADD_SPACE_GALLERY, formData)
  },

  getVenueSpaceTypes(formData) {
    return apiClient.post(ENDPOINTS.GET_VENUE_SPACE_TYPES, formData)
  },

  getVenueSpaceSeatConfig(formData) {
    return apiClient.post(ENDPOINTS.GET_VENUE_SPACE_SEAT_CONFIG, formData)
  },

  addVenueSpace(formData) {
    return apiClient.post(ENDPOINTS.ADD_VENUE_SPACE, formData)
  },

  updateVenueSpace(formData) {
    return apiClient.post(ENDPOINTS.UPDATE_VENUE_SPACE, formData)
  },

  deleteVenueSpace(formData) {
    return apiClient.post(ENDPOINTS.DELETE_VENUE_SPACE, formData)
  },

  listVenueSpaces(formData) {
    return apiClient.post(ENDPOINTS.LIST_VENUE_SPACES, formData)
  },

  addVenue(formData) {
    return apiClient.post(ENDPOINTS.ADD_VENUE, formData)
  },

  updateVenue(formData) {
    return apiClient.post(ENDPOINTS.UPDATE_VENUE, formData)
  },

  deleteVenue(formData) {
    return apiClient.post(ENDPOINTS.DELETE_VENUE, formData)
  },

  getSubcategories(formData) {
    return apiClient.post(ENDPOINTS.GET_SUBCATEGORIES, formData)
  },

  listVendorPackages(formData) {
    return apiClient.post(ENDPOINTS.LIST_VENDOR_PACKAGES, formData)
  },

  addVendorPackage(formData) {
    return apiClient.post(ENDPOINTS.ADD_VENDOR_PACKAGE, formData)
  },

  deleteVendorPackage(formData) {
    return apiClient.post(ENDPOINTS.DELETE_VENDOR_PACKAGE, formData)
  },

  updateVendorPackage(formData) {
    return apiClient.post(ENDPOINTS.UPDATE_VENDOR_PACKAGE, formData)
  }
}

export default vendorApi
